import React from 'react';
import AdminQuizPage from '../../body/AdminQuizPage';
import { ADMIN_QUIZ_MODULES } from '../../../../apis/quiz';

const introContent = (
  <div className='space-y-4 text-left'>
    <p className='font-bold text-2xl'>
      Congratulations! You have finished the training content!
    </p>
    <p className='text-xl leading-relaxed'>
      To complete the training, a score of <b>80%</b> or higher on the quiz is
      required.
    </p>
    <p>
      <b>
        Before completing the final quiz, please review the ezParent Hybrid
        Group Facilitation Manual.
      </b>
    </p>
  </div>
);

const HybridQuiz = () => (
  <AdminQuizPage
    moduleKey={ADMIN_QUIZ_MODULES.hybridDelivery}
    title='Final Quiz'
    introContent={introContent}
    pdfSrc='/resource-library/Hybrid-Group-Facilitation-Manual.pdf'
    pdfText={
      <>
        <i>ez</i>Parent Hybrid Group Facilitation Manual
      </>
    }
  />
);

export default HybridQuiz;
